<template>
  <modal
    :active="active"
    size="auto"
    :close-on-click-outside="false"
    primary-button-label="Submit"
    tertiary-button-label="Cancel"
    @onClose="$emit('onModalClose')"
    @onConfirm="submitEdit">
    <template #header>
      <p>Edit Description</p>
    </template>
    <template #content>
      <div class="modal-content">
        <text-editor
          v-model="localDescription"
          :default-comments="localDescription"
          :max-length="4000"
          :error="editorError"
          error-msg="Comments supports maximum 4000 characters."
          @commentsChange="onEditorChange" />
      </div>
    </template>
  </modal>
</template>

<script>
import TextEditor from "@/components/common/TextEditor/TextEditor.vue";

export default {
  name: "EditCommentsModal",
  components: { TextEditor },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    currentDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editorError: false,
      localDescription: this.currentDescription || "", // Create a local data property
    };
  },
  watch: {
    currentDescription(newVal) {
      this.localDescription = newVal; // Update localDescription if prop changes
    },
  },
  methods: {
    submitEdit() {
      if (this.localDescription.plainText.length > 4000) {
        this.editorError = true;
        return;
      }
      //console.log("new desc : " + this.localDescription);
      this.$emit("onEdit", this.localDescription); // Emit the localDescription
      this.$emit("onModalClose");
    },
    onEditorChange(html) {
      this.localDescription = html; // Update localDescription
    },
  },
};
</script>
<style scoped>
.modal-content {
  max-height: 500px;
  max-width: 700px;
  overflow-y: auto;
}
</style>
